<template>
    <div id="layout">
        <layout-header></layout-header>
        <div id="layout_main" :class="{'page--login':isLogin}">
            <transition name="change">
                <router-view/>
            </transition>
        </div>
        <layout-nav></layout-nav>
        <div id="popup" v-on:click="closePopup">
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',
    computed: {
        isLogin: function () {
            return this.$route.meta.splash;
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                document.title = (typeof this.isLogin === 'undefined') ? localStorage.getItem('hotel') : 'HORES WebApp';
                if (document.querySelector('#layout_header') !== null) {
                    document.querySelector('#layout_header').classList.remove('mod--not-top');
                }
            }
        }
    }, methods: {
        closePopup() {
            const el = document.getElementById('popup');
            el.classList.remove('visible')
        }
    }
}
</script>

<style lang="less">
@import './less/core.less';
</style>



// WEBPACK FOOTER //
// src/App.vue